{
  "name": "@jillen/analytics",
  "version": "5.0.0",
  "description": "Lightweight human-visit and Web Vitals analytics for React apps. Framework-agnostic core with a Next.js adapter.",
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.mjs",
      "require": "./dist/index.js"
    },
    "./next": {
      "types": "./dist/next.d.ts",
      "import": "./dist/next.mjs",
      "require": "./dist/next.js"
    }
  },
  "files": [
    "dist",
    "README.md",
    "CHANGELOG.md",
    "LICENSE"
  ],
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "clean": "rm -rf dist",
    "prepublishOnly": "npm run clean && npm run build",
    "test": "echo \"Error: no test specified\" && exit 1"
  },
  "keywords": [
    "analytics",
    "tracking",
    "web-analytics",
    "web-vitals",
    "react",
    "nextjs",
    "vite",
    "typescript"
  ],
  "author": "Jillen",
  "license": "MIT",
  "peerDependencies": {
    "next": ">=13.0.0",
    "react": ">=18.0.0"
  },
  "peerDependenciesMeta": {
    "next": {
      "optional": true
    }
  },
  "dependencies": {
    "isbot": "^5.1.31",
    "web-vitals": "^5.1.0"
  },
  "devDependencies": {
    "@types/node": "^20.19.23",
    "@types/react": "^19.2.2",
    "tsup": "^8.5.0",
    "typescript": "^5.9.3"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/jillen/analytics.git"
  },
  "bugs": {
    "url": "https://github.com/jillen/analytics/issues"
  },
  "homepage": "https://github.com/jillen/analytics#readme"
}
